export const emptyStringToNull = <T extends number | string>(value: T, originalValue: T) => {
  if (typeof originalValue === 'string' && originalValue === '') {
    return null;
  }

  return value;
};

export const emptyStringToUndefined = <T extends number | string>(value: T, originalValue: T) => {
  if (typeof originalValue === 'string' && originalValue === '') {
    return undefined;
  }

  return value;
};
